/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetClockinEssentialsRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetClockinEssentialsResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getClockinEssentials = (request: GetClockinEssentialsRequest, options?: CashRequestOptions) => post<GetClockinEssentialsRequest, GetClockinEssentialsResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetClockinEssentials", request, {...options, rejectOnError: true })